import {getCurrentCompanyUUID} from '@/utils/company'
import {reportHandledError} from '@/utils/sentry'

const STORAGE_PREFIX = 'listPagination';

function getStorageKey(listName) {
    const companyUUID = getCurrentCompanyUUID();
    if (companyUUID === '') {
        return null;
    }
    return `${STORAGE_PREFIX}:${companyUUID}:${listName}`;
}

export function readListPagination(listName) {
    const storageKey = getStorageKey(listName);
    if (storageKey == null) {
        return null;
    }
    const storedValue = sessionStorage.getItem(storageKey);
    if (storedValue == null) {
        return null;
    }
    try {
        const pagination = JSON.parse(storedValue);
        if (!Number.isInteger(pagination.currentPage) || pagination.currentPage < 1
            || !Number.isInteger(pagination.pageSize) || pagination.pageSize < 1) {
            sessionStorage.removeItem(storageKey);
            return null;
        }
        return pagination;
    } catch (error) {
        reportHandledError(error, {
            module: 'list_state',
            operation: 'read_pagination',
            context: {listName: listName}
        });
        sessionStorage.removeItem(storageKey);
        return null;
    }
}

export function writeListPagination(listName, currentPage, pageSize) {
    const storageKey = getStorageKey(listName);
    if (storageKey == null) {
        return;
    }
    sessionStorage.setItem(storageKey, JSON.stringify({
        currentPage: currentPage,
        pageSize: pageSize
    }));
}
